export const CONST = {
  // BACKEND_URL: 'http://localhost:5000/api/v1',
  // BACKEND_HOST: 'http://localhost:5000/',


  BACKEND_URL: 'https://talentplusstrengths.com/api/v1',
  BACKEND_HOST: 'https://talentplusstrengths.com/',

  SURVEY_URL: "https://talentplusstrengths.com:8080//#/v1/",
  SURVEY_LOGIN: "https://talentplusstrengths.com:8080//#/login/",

  SURVEY_ASSESSMENT: "https://talentplusstrengths.com//#/assessment/surveylogin",
  SURVEY_ASSESSMENT_USER: "https://talentplusstrengths.com//#/assessment/sign-in",

  COACH_LOGIN: "https://talentplusstrengths.com//#/assessment/coachlogin",

  MERCHANT_ID: "2484086", //Int or String

  CRYPTO_KEY: "secretkey1345100237401", //Int or String

  R_KEY: "rzp_live_RWtn8JzDxoJ33F",

  MANAGER_ID_TYPE: "Int", //Int or String

  IMAGES_URL: "./img/",

  APP_NAME: 'PLUS HR',
  FOOTER_TEXT: '©2025 Happyplus. All rights reserved.',

};
